
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class YoutubeVideo extends Vue {

  @Prop() private id!: string;
  @Prop() private link!: string;
  @Prop() private title!: string;
  @Prop() private viewCount!: number;
  @Prop() private publishedAt!: string;

  private dateDiffInDays(a: Date, b: Date) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
  }

  private getTimeSinceVideoUploaded(date: Date): string {
    const nbDays = this.dateDiffInDays(date, new Date());
    if (nbDays === 0) {
      return 'aujourd\'hui';
    } else if (nbDays === 1) {
      return 'il y a 1 jour';
    } else if (nbDays < 7) {
      return `il y a ${nbDays} jours`;
    } else if (nbDays >= 7 && nbDays < 14) {
      return 'il y a 1 semaine';
    } else if (nbDays >= 14 && nbDays < 21) {
      return 'il y a 2 semaines';
    } else if (nbDays >= 21 && nbDays < 28) {
      return 'il y a 3 semaines';
    } else if (nbDays >= 28 && nbDays < 365) {
      return `il y a ${Math.trunc(nbDays / 30)} mois`;
    } else if (nbDays >= 365 && nbDays < 730) {
      return 'il y a 1 an';
    } else if (nbDays >= 730) {
      return `il y a ${Math.trunc(nbDays / 365)} ans`;
    } else {
      return '';
    }
  }

}
